import { useTenantAvailable } from '@api/application-configuration';
import { useAppSelector } from '@unistocks/shared/hooks/redux-hooks';
import { isTokenValid } from '@unistocks/shared/hooks/use-auth-token';
import { selectToken } from '@unistocks/shared/store/root.slice';
import { Href } from 'expo-router';
import { useMemo } from 'react';

export const useStartPage = (): Href => {
  const token = useAppSelector(selectToken);
  const isValid = isTokenValid(token);
  const isHost = useTenantAvailable() === false;

  const href = useMemo<Href>(() => {
    if (!isValid) return '/(auth)/login';

    return isHost ? '/(admin)' : '/(tabs)';
  }, [isHost, isValid]);

  return href;
};
